import Composto from './Composto'

export default class Candidato {

  constructor() {
    this.id = 0;
    this.foto = new Composto();
    this.nome = "";
    this.genero = new Composto();
    this.telefone = "";
    this.whatsapp = "";
    this.facebook = "";
    this.cpf = "";
    this.data_nascimento = "";
    this.celular = "";
    this.skype = "";
    this.estado_civil = new Composto();
    this.numero_filhos = "";
    this.pcd = "";
    this.pcd_descricao = "";
    this.cnh_categoria = new Composto();
    this.curriculo = "";
    this.pretensao_salarial = "";
    this.email = "";
    this.cep = "";
    this.logradouro = "";
    this.numero = "";
    this.complemento = "";
    this.bairro = "";
    //this.cidade_id = new Composto(),
    //this.estado_id = new Composto(),
    this.cidade_id = "",
    this.estado_id = "",
    this.senha = "";
    this.cargos = [];
    this.cargos_area = [];
    this.experiencia_lines = [];
    this.formacao_lines = [];
    this.idioma_lines = [];
    this.curso_lines = [];
    this.cnh = 0;
    this.pcd = 0;
    this.primeiro_emprego = "Nao";
    this.token_google = '';
    this.token_email = '';
  }
}
